import { ChipProps } from '@mui/material';
import { OnboardingStatus, TerminalReaderStatus } from './billingEntity.model';

/**
 * i18n namespace of the Stripe billing section, shared by the section, its entity rows and the
 * two onboarding round-trip pages.
 */
export const STRIPE_KEY_PREFIX =
  'doctor-dashboard.hospitalParams.billing.stripe';

/**
 * i18n keys and theme colors for the Stripe onboarding statuses. Follows the
 * {@link billingLineStatusLabelKey} precedent: the color map is a total `Record<>` so an
 * unmapped status fails the build.
 */
export const onboardingStatusLabelKey = (status: OnboardingStatus) =>
  `${STRIPE_KEY_PREFIX}.status.${status}` as const;

export const ONBOARDING_STATUS_CHIP_COLOR: Record<
  OnboardingStatus,
  ChipProps['color']
> = {
  NOT_STARTED: 'default',
  PENDING: 'warning',
  ACTIVE: 'success',
  PAST_DUE: 'warning',
  SUSPENDED: 'error'
};

/**
 * Reachability of a card reader, worded once for the settings list and the desk-payment
 * dialog's reader picker.
 */
export const terminalReaderStatusLabelKey = (status: TerminalReaderStatus) =>
  `${STRIPE_KEY_PREFIX}.readers.status.${status}` as const;

/**
 * The two statuses whose label is not self-explanatory: `NOT_STARTED`, where nothing exists on
 * the Stripe side yet (the connected account is created by the first onboarding link), and
 * `SUSPENDED`, which no action on this screen can lift.
 */
export const onboardingStatusHintKey = (
  status: OnboardingStatus
): string | undefined => {
  switch (status) {
    case 'NOT_STARTED':
      return `${STRIPE_KEY_PREFIX}.status.notStartedHint`;
    case 'SUSPENDED':
      return `${STRIPE_KEY_PREFIX}.status.suspendedHint`;
    default:
      return undefined;
  }
};
